import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/AdminPageLayout/AdminPageLayout";
import ErrorDisplay from "../../../components/ErrorDisplay/ErrorDisplay";
import { Headings } from "../../../components/Headings";
import LoadingMask from "../../../components/LoadingMask/LoadingMask";
import { getAllPlaces } from "../../../services/placeService";
import { Place } from "../../../types/Place";
import { debugLogError } from "../../../utils/debug-log-error";
import "./AdminPlacesPage.scss";

const AdminPlacesPage: React.FC = () => {
  const [places, setPlaces] = useState<Place[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlaces = async () => {
      setIsLoading(true);
      try {
        const fetchedPlaces = await getAllPlaces();
        setPlaces(fetchedPlaces);
        setError(null);
      } catch (err) {
        debugLogError("AdminPlacesPage", err);
        setError("Failed to fetch places. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlaces();
  }, []);

  if (isLoading) {
    return <LoadingMask message="Loading places..." />;
  }

  return (
    <AdminPageLayout title="Manage Places">
      <div className="admin-places-page-content">
        <Link to="/admin" className="btn btn-outline-primary">
          &larr; Admin
        </Link>
        <Headings.Page>Manage Places</Headings.Page>
        {error && <ErrorDisplay error={error} />}
        {!error && (
          <>
            {places.length === 0 ? (
              <div className="alert alert-info">No places found.</div>
            ) : (
              <ul className="places-list">
                {places.map((place) => (
                  <li key={place.googlePlaceId} className="place-item">
                    <Link to={`/admin/places/${place.googlePlaceId}`}>
                      <strong>{place.name}</strong>
                      <p>{place.address}</p>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </>
        )}
      </div>
    </AdminPageLayout>
  );
};

export default AdminPlacesPage;
